import React, { useEffect, useState } from 'react';
import { Check, FileText, Heart, Compass, AlertTriangle, Clock } from 'lucide-react';
import { Section } from './Shared';
import { Pricing } from './Pricing';
import { CandleFlame, TearDrop } from './SacredIcons';
const LaunchUrgency = () => {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 7,
    s: 57
  });
  const [spotsTaken, setSpotsTaken] = useState(() => {
    const saved = typeof window !== 'undefined' ? sessionStorage.getItem('constelaciones-launch-spots') : null;
    if (saved) {
      const {
        value,
        timestamp
      } = JSON.parse(saved);
      const elapsed = (Date.now() - timestamp) / 1000;
      const increment = Math.floor(elapsed / 60);
      return Math.min(value + increment, 92);
    }
    return 68;
  });
  useEffect(() => {
    sessionStorage.setItem('constelaciones-launch-spots', JSON.stringify({
      value: spotsTaken,
      timestamp: Date.now()
    }));
  }, [spotsTaken]);
  useEffect(() => {
    const id = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(id);
  }, []);
  useEffect(() => {
    const id = setInterval(() => {
      setSpotsTaken(prev => {
        if (prev >= 92) return prev;
        return Math.random() < 0.4 ? prev + 1 : prev;
      });
    }, 45000 + Math.random() * 30000);
    return () => clearInterval(id);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  const TimeBox = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-217">
      <div className="bg-brand-violet text-white font-mono font-bold text-2xl md:text-4xl rounded-xl px-3 md:px-5 py-2 md:py-3 min-w-[56px] md:min-w-[80px] text-center shadow-md tabular-nums border border-brand-goldLight/40" data-id="element-218">
        {fmt(value)}
      </div>
      <span className="text-[10px] md:text-xs font-medium text-brand-text/70 mt-1.5 uppercase tracking-wider" data-id="element-219">
        {label}
      </span>
    </div>;
  return <div className="max-w-4xl mx-auto mb-12" data-id="element-220">
      <div className="glass-panel rounded-3xl p-6 md:p-8 border-2 border-brand-gold/40 bg-gradient-to-br from-white/95 to-brand-goldLight/10 shadow-[0_10px_40px_rgba(201,169,97,0.12)]" data-id="element-221">
        <div className="flex items-center justify-center gap-2 mb-5" data-id="element-222">
          <Clock className="w-5 h-5 md:w-6 md:h-6 text-brand-goldDark shrink-0" data-id="element-223" />
          <h3 className="font-serif font-bold text-base md:text-xl text-brand-violetDark text-center" data-id="element-224">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h3>
        </div>

        <div className="flex items-center justify-center gap-2 md:gap-4 mb-5" data-id="element-225">
          <TimeBox value={timeLeft.h} label="Horas" data-id="element-226" />
          <span className="text-2xl md:text-4xl font-bold text-brand-gold/60 pb-5" data-id="element-227">
            :
          </span>
          <TimeBox value={timeLeft.m} label="Min" data-id="element-228" />
          <span className="text-2xl md:text-4xl font-bold text-brand-gold/60 pb-5" data-id="element-229">
            :
          </span>
          <TimeBox value={timeLeft.s} label="Seg" data-id="element-230" />
        </div>

        <div className="flex items-center justify-center gap-2 bg-amber-50 border border-amber-300/60 rounded-xl px-4 py-3 mb-6" data-id="element-231">
          <AlertTriangle className="w-4 h-4 md:w-5 md:h-5 text-amber-600 shrink-0" data-id="element-232" />
          <p className="text-sm md:text-base font-semibold text-amber-900 text-center" data-id="element-233">
            Después sube $10.000 ARS.{' '}
            <span className="text-brand-violet" data-id="element-234">No vuelve.</span>
          </p>
        </div>

        <div className="bg-white/80 rounded-2xl p-4 md:p-5 border border-brand-gold/30" data-id="element-235">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 mb-3" data-id="element-236">
            <div className="flex items-center gap-2" data-id="element-237">
              <span className="relative flex h-2.5 w-2.5" data-id="element-238">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-burgundy opacity-75" data-id="element-239"></span>
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-brand-burgundy" data-id="element-240"></span>
              </span>
              <span className="font-semibold text-sm md:text-base text-brand-text" data-id="element-241">
                Cupos al precio de lanzamiento
              </span>
            </div>
            <span className="text-xs md:text-sm font-bold text-brand-violet uppercase tracking-wide" data-id="element-242">
              Quedan pocos
            </span>
          </div>

          <div className="w-full bg-brand-gold/15 rounded-full h-2.5 overflow-hidden mb-2" data-id="element-243">
            <div className="bg-gradient-to-r from-brand-gold to-brand-goldDark h-2.5 rounded-full transition-all duration-1000 ease-out" style={{
            width: `${spotsTaken}%`
          }} data-id="element-244" />
          </div>

          <p className="text-xs md:text-sm text-brand-text/70 text-center" data-id="element-245">
            <strong className="text-brand-violet" data-id="element-246">{spotsTaken}%</strong> de los
            cupos al precio de lanzamiento ya tomados
          </p>
        </div>
      </div>
    </div>;
};
const tomos = [{
  num: '01',
  title: 'TOMO 1 — PROTOCOLO DE ENCUADRE SISTÉMICO',
  tagline: 'La base que ordena todo lo que viene.',
  cover: 'https://cdn.magicpatterns.com/uploads/18urnUtjnupFuAZ9stCXVs/portada_tomo_1.png',
  color: 'text-brand-forest',
  bgColor: 'bg-brand-forest/5',
  borderColor: 'border-brand-forest/20',
  bullets: ['Protocolo de primera entrevista', 'Ficha de admisión imprimible', 'Consentimiento informado', 'Guía de honorarios']
}, {
  num: '02',
  title: 'TOMO 2 — CARTOGRAFÍA DEL CAMPO',
  tagline: 'Ver el sistema antes de intervenir.',
  cover: 'https://cdn.magicpatterns.com/uploads/9rPaTQt7yvCh9wBaj79GwD/portada_tomo_2.png',
  color: 'text-brand-violet',
  bgColor: 'bg-brand-violetLight/10',
  borderColor: 'border-brand-violetLight/30',
  bullets: ['Simbología completa del genograma', 'Plantillas de 2, 3 y 4 generaciones', 'Lectura de patrones transgeneracionales', 'Detección de aniversarios sistémicos']
}, {
  num: '03',
  title: 'TOMO 3 — BITÁCORA FENOMENOLÓGICA',
  tagline: 'Sesiones que se vuelven procesos.',
  cover: 'https://cdn.magicpatterns.com/uploads/9z7iW8wV5Azae7a9gi3Qq2/Portada_tomo_3_.png',
  color: 'text-brand-goldDark',
  bgColor: 'bg-brand-gold/5',
  borderColor: 'border-brand-gold/20',
  bullets: ['Planilla sesión a sesión', 'Notación rápida del campo', 'Indicadores de avance', 'Planilla de cierre de proceso']
}, {
  num: '04',
  title: 'TOMO 4 — VADEMÉCUM DE INTERVENCIÓN',
  tagline: 'La guía rápida cuando el campo se detiene.',
  cover: 'https://cdn.magicpatterns.com/uploads/9sAoTGJeCPYbpXc3vjbsAP/Portada_tomo_4.png',
  color: 'text-brand-burgundy',
  bgColor: 'bg-brand-burgundy/5',
  borderColor: 'border-brand-burgundy/20',
  bullets: ['Tabla maestra de síntomas', 'Intervenciones por tipo de conflicto', 'Trabajo con duelos bloqueados', 'Lectura sistémica de adicciones']
}, {
  num: '05',
  title: 'TOMO 5 — DESPEDIDA Y CUIDADO',
  tagline: 'Cerrar el círculo y cuidarte como terapeuta.',
  cover: 'https://cdn.magicpatterns.com/uploads/iDeRG69rnpreraSjCUBQxv/Portada_tomo_5.png',
  color: 'text-brand-violetDark',
  bgColor: 'bg-brand-violetDark/5',
  borderColor: 'border-brand-violetDark/20',
  bullets: ['Señales para cerrar un proceso', 'Protocolo de sesión de despedida', 'Ritual de limpieza post-sesión', 'Bitácora personal del terapeuta']
}];
const bonuses = [{
  icon: Heart,
  title: 'Frases Sanadoras',
  desc: 'La frase justa en el momento exacto. Banco clasificado por vínculo.',
  color: 'text-brand-violet',
  bgColor: 'bg-brand-violet/10',
  borderColor: 'border-brand-violet/30',
  price: '$12.000'
}, {
  icon: FileText,
  title: 'Agenda Clínica 30 Días',
  desc: 'Ordená tu práctica con planificación mensual, semanal y diaria.',
  color: 'text-brand-burgundy',
  bgColor: 'bg-brand-burgundy/10',
  borderColor: 'border-brand-burgundy/30',
  price: '$10.000'
}, {
  icon: Compass,
  title: 'Protocolos Rápidos',
  desc: 'Qué preguntar, registrar y mirar desde la primera sesión.',
  color: 'text-brand-goldDark',
  bgColor: 'bg-brand-gold/10',
  borderColor: 'border-brand-gold/30',
  price: '$10.000'
}];
const planComparison = [{
  situation: 'El campo se detiene y no sabés hacia dónde ir',
  without: 'Improvisás o cambiás de tema',
  with: 'Protocolo de intervención avanzada. Dirección clara.'
}, {
  situation: 'El consultante llega resistente y no se mueve',
  without: 'Forzás el proceso o te frustrás',
  with: 'Lectura sistémica de la resistencia aplicada en sesión'
}, {
  situation: 'Sentís que te perdiste en el campo del consultante',
  without: 'No sabés distinguir si es tuyo o del campo',
  with: 'Protocolo de contratransferencia sistémica.'
}, {
  situation: 'Querés trabajar trauma profundo con seguridad',
  without: 'Evitás el tema o lo abrís sin contención',
  with: 'Protocolo de regulación somática paso a paso'
}, {
  situation: 'Tenés dificultad para cobrar lo que vale tu trabajo',
  without: 'Seguís con honorarios bajos por creencia propia',
  with: 'Revisión sistémica del propio sistema económico'
}, {
  situation: 'No sabés cuándo cerrar un proceso',
  without: 'Lo extendés más de lo necesario',
  with: '7 señales de cierre y protocolo de despedida de maestría'
}, {
  situation: 'Sesiones que no tienen la profundidad que querés',
  without: 'La técnica está pero falta algo',
  with: 'Desarrollo de la presencia vacía como instrumento'
}];
export const MethodOverview = () => {
  return <Section id="method" className="relative" data-id="element-247">
      {/* Decorative Sacred elements */}
      <CandleFlame className="hidden lg:block absolute top-20 right-[3%] w-8 h-12 opacity-25 animate-float-soft" style={{
      transform: 'rotate(-15deg)'
    }} data-id="element-248" />
      <TearDrop className="hidden lg:block absolute top-60 left-[2%] w-10 h-12 opacity-30 animate-float-soft" style={{
      transform: 'rotate(12deg)',
      animationDelay: '1.5s'
    }} data-id="element-249" />

      {/* Compact header + mockup */}
      <div className="max-w-4xl mx-auto mb-5 md:mb-6" data-id="element-250">
        <div className="text-center mb-2.5 md:mb-3" data-id="element-251">
          <div className="inline-flex items-center space-x-1.5 bg-white border border-brand-gold/40 px-3 py-0.5 rounded-full mb-1.5 shadow-sm" data-id="element-252">
            <span className="text-sm" data-id="element-253">🏆</span>
            <span className="font-serif font-semibold tracking-wider text-brand-violetDark text-[10px] md:text-xs" data-id="element-254">
              KIT CONSTELACIONES FAMILIARES™
            </span>
          </div>
          <h2 className="text-lg md:text-3xl font-display font-bold leading-tight text-brand-violetDark mb-0.5" data-id="element-255">
            5 Tomos + 3 Bonus
          </h2>
          <p className="text-brand-text/70 text-[11px] md:text-sm" data-id="element-256">
            375 páginas — Todo resuelto.
          </p>
        </div>

        <div className="relative z-10 w-full max-w-[260px] sm:max-w-sm md:max-w-lg mx-auto flex justify-center" data-id="element-257">
          <img src="https://cdn.magicpatterns.com/uploads/pj1cxE8MnMjhng1XdvaYtx/Mokup_constelaciones_2B_maestria.png" alt="Kit Constelaciones Familiares + Maestría en Consulta" className="w-full h-auto drop-shadow-2xl" draggable={false} data-id="element-258" />
        </div>
      </div>

      <div className="max-w-4xl mx-auto mb-8" data-id="element-259">
        <div className="space-y-3 md:space-y-4" data-id="element-260">
          {tomos.map((tomo, i) => <div key={i} className={`rounded-xl p-3 md:p-4 border ${tomo.bgColor} ${tomo.borderColor} backdrop-blur-sm shadow-sm`} data-id="element-261">
              <div className="flex flex-row items-center gap-3 md:gap-5" data-id="element-262">
                <div className="shrink-0 w-20 sm:w-24 md:w-28" data-id="element-263">
                  <img src={tomo.cover} alt={tomo.title} className="w-full h-auto rounded-md shadow-md" draggable={false} data-id="element-264" />
                </div>

                <div className="flex-grow min-w-0" data-id="element-265">
                  <div className={`inline-block text-[9px] md:text-[10px] font-mono font-bold ${tomo.color} ${tomo.bgColor} border ${tomo.borderColor} px-1.5 py-0.5 rounded mb-1`} data-id="element-266">
                    TOMO {tomo.num}
                  </div>
                  <h4 className="font-serif font-bold mb-0.5 text-sm md:text-base text-brand-violetDark leading-tight" data-id="element-267">
                    {tomo.title.split('—')[1]?.trim() || tomo.title}
                  </h4>
                  <p className="text-brand-text/80 italic mb-2 text-[11px] md:text-sm leading-snug" data-id="element-268">
                    {tomo.tagline}
                  </p>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-3 gap-y-1 text-[11px] md:text-xs text-brand-text/85" data-id="element-269">
                    {tomo.bullets.map((bullet, j) => <div key={j} className="flex items-start" data-id="element-270">
                        <Check className={`w-3 h-3 mr-1.5 mt-0.5 shrink-0 ${tomo.color}`} data-id="element-271" />
                        <span className="leading-snug" data-id="element-272">{bullet}</span>
                      </div>)}
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        <div className="text-center mb-4 mt-10" data-id="element-273">
          <h3 className="text-lg md:text-xl font-serif font-bold text-brand-violetDark" data-id="element-274">
            🎁 3 BONUS ESTRATÉGICOS
          </h3>
          <p className="text-[10px] md:text-xs uppercase tracking-wider text-brand-goldDark mt-0.5 font-bold" data-id="element-275">
            SIEMPRE INCLUIDOS
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-276">
          {bonuses.map((bonus, i) => {
          const Icon = bonus.icon;
          return <div key={i} className="glass-panel rounded-xl p-4 border-brand-gold/30 relative bg-white/90 flex items-start gap-3" data-id="element-277">
                <div className={`${bonus.bgColor} ${bonus.color} rounded-lg p-2 shrink-0`} data-id="element-278">
                  <Icon className="w-5 h-5" data-id="element-279" />
                </div>
                <div className="flex-grow min-w-0" data-id="element-280">
                  <div className="flex items-center gap-2 mb-1" data-id="element-281">
                    <h4 className="text-sm md:text-base font-serif font-bold text-brand-text leading-tight" data-id="element-282">
                      {bonus.title}
                    </h4>
                    <span className="bg-brand-goldDark text-white text-[10px] font-bold px-2 py-0.5 rounded shrink-0" data-id="element-283">
                      GRATIS
                    </span>
                  </div>
                  <p className="text-xs text-brand-text/70 leading-snug mb-1.5" data-id="element-284">
                    {bonus.desc}
                  </p>
                  <p className="text-[11px] text-brand-text/50" data-id="element-285">
                    <span className="line-through" data-id="element-286">{bonus.price}</span>
                    <span className="ml-1.5 font-semibold text-brand-goldDark" data-id="element-287">
                      → Incluido
                    </span>
                  </p>
                </div>
              </div>;
        })}
        </div>

        <div className="text-center mt-5" data-id="element-288">
          <div className="inline-block glass-panel px-5 py-2 rounded-full border-brand-gold/30 bg-white/80" data-id="element-289">
            <p className="text-xs md:text-sm font-medium text-brand-text/80" data-id="element-290">
              Valor total bonos{' '}
              <span className="line-through text-brand-text/50" data-id="element-291">$30.000</span>{' '}
              <span className="text-brand-violet font-bold" data-id="element-292">
                → GRATIS con tu Kit Constelaciones
              </span>
            </p>
          </div>
        </div>
      </div>

      <LaunchUrgency data-id="element-293" />

      <Pricing data-id="element-294" />

      {/* Maestría Comparison */}
      <div className="max-w-5xl mx-auto mb-6 mt-8" data-id="element-295">
        <div className="bg-white rounded-2xl p-5 md:p-8 border border-brand-gold/30 shadow-sm" data-id="element-296">
          <p className="text-base md:text-xl font-serif font-bold text-brand-violetDark mb-6 text-center" data-id="element-297">
            🎓 ¿Qué agrega la Maestría en Consulta?
          </p>

          <div className="hidden md:block" data-id="element-298">
            <div className="grid grid-cols-3 gap-4 text-[11px] font-semibold uppercase tracking-wide text-brand-text/60 border-b border-brand-gold/20 pb-3 mb-3" data-id="element-299">
              <div data-id="element-300">Situación</div>
              <div className="text-brand-burgundy" data-id="element-301">❌ Sin Maestría</div>
              <div className="text-brand-violet" data-id="element-302">✅ Con Maestría</div>
            </div>
            <div className="space-y-3" data-id="element-303">
              {planComparison.map((row, i) => <div key={i} className="grid grid-cols-3 gap-4 text-xs md:text-sm text-brand-text/80 py-2 border-b border-brand-gold/10 last:border-0" data-id="element-304">
                  <div className="font-medium pr-4" data-id="element-305">{row.situation}</div>
                  <div className="text-brand-burgundy/80 pr-4" data-id="element-306">
                    {row.without}
                  </div>
                  <div className="text-brand-violet font-medium" data-id="element-307">
                    {row.with}
                  </div>
                </div>)}
            </div>
          </div>

          <div className="md:hidden space-y-4" data-id="element-308">
            {planComparison.map((row, i) => <div key={i} className="border-b border-brand-gold/15 pb-4 last:border-0 last:pb-0" data-id="element-309">
                <p className="text-sm font-semibold text-brand-text mb-2" data-id="element-310">
                  {row.situation}
                </p>
                <div className="text-xs text-brand-burgundy/80 mb-1" data-id="element-311">
                  ❌ {row.without}
                </div>
                <div className="text-xs text-brand-violet font-medium" data-id="element-312">
                  ✅ {row.with}
                </div>
              </div>)}
          </div>

          <p className="text-sm md:text-base font-medium text-brand-goldDark italic text-center mt-8" data-id="element-313">
            Un solo proceso mejorado con esta guía ya paga la diferencia de
            precio.
          </p>
        </div>
      </div>
    </Section>;
};